// extracted by mini-css-extract-plugin
export default {"title":"App_title__wJw7v","section":"App_section__5ICGn","sectionBox":"App_sectionBox__BJ3yy","body":"App_body__00BrA","whole":"App_whole__czk1w"};